// extracted by mini-css-extract-plugin
module.exports = {"version":"Signin_version__1kSdj","linkContainer":"Signin_linkContainer__2btnv","link":"Signin_link__1Rhcg"};